import type { AreasSearch } from '@/routes/_protected/$tenantKey/settings/_system-master-settings/areas/-models'

import type { FetchAreasListQuery } from '../api'

export function buildFetchAreasQuery(
  tenantKey: string,
  deps: AreasSearch
): FetchAreasListQuery {
  return {
    tenantKey,
    query: {
      ...deps
    }
  }
}
